






























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { pagination, loadingCatch, loading } from "@root/lib/decorator";
import RefundChanngeLog from "@/components/pages/Order/ChangeLog.vue";

const common = namespace("common");
const express = namespace("express");

@Component({
  filters: {
    dNull(val) {
      return val || "-";
    }
  }
})
@loading()
export default class WtInspect extends Vue {
  @common.Action queryDataDictionaryListLang;
  @express.Action queryCouponDetailList;

  private dataList = [];
  private tabLoading = false;
  private loading = false;

  get dataListComputed() {
    return this.dataList;
  }
  get routerCode() {
    return (this.$route.query.code || "") as any;
  }

  async created() {
    this.initData();
  }

  async initData() {
    this.loading = true;
    if (!this.routerCode) {
      this.$router.push({
        name: "couponPCR"
      });
      return;
    }
    await this.getData();
  }

  @loadingCatch
  async getData() {
    try {
      const searchForm = {
        input: {
          couponCode: this.routerCode
        }
      };
      let { total, list } = await this.queryCouponDetailList(searchForm);
      (this as any).total = total;
      this.dataList = list || [];
    } catch (err) {
      this.dataList = [];
      console.error(err);
      (this as any).total = 0;
    }
  }
}
